import React, { useCallback, useMemo } from 'react';
import Switch from "react-switch";
import useActiveThemeVariation from '../../../../themes/hooks/UseActiveThemeVariation';
import useTheme from '../../../../themes/hooks/UseTheme';
import StackLayout from '../../../layouts/stackLayout/StackLayoutComponent';
import Text from '../../../core/text/TextComponent';
import useStyleObject from '../../../../themes/hooks/UseStyleObject';
import { onUndefinedUseDefined } from '../../../../../helpers/ValueHelper';
var CheckboxImplementation = function (props) {
    var checked = props.checked, label = props.label, disabled = props.disabled, onChange = props.onChange;
    var theme = useTheme();
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.checkbox; });
    var offColor = useMemo(function () { return theme.resolveColor(activeThemeVariation.offColor); }, [activeThemeVariation.offColor]);
    var onColor = useMemo(function () { return theme.resolveColor(activeThemeVariation.onColor); }, [activeThemeVariation.onColor]);
    var height = useMemo(function () { return theme.resolveNumericFactor(activeThemeVariation.size) || 28; }, [activeThemeVariation.size]);
    var width = useMemo(function () { return height * 2; }, [height]);
    var margin = useStyleObject(props, function (x) { return x.advancedControlsThemes.checkbox; }, 'margin');
    var handlePress = useCallback(function () {
        if (disabled) {
            return;
        }
        onChange(!checked);
    }, [onChange, checked, disabled]);
    var handleChange = useCallback(function (checked, event) {
        event.stopPropagation();
        onChange(checked);
    }, [onChange]);
    return (React.createElement(StackLayout, { customStyle: margin, horizontal: true, vCenter: true, onPress: handlePress },
        React.createElement(Switch, { checked: checked || false, onChange: handleChange, offColor: offColor, onColor: onColor, height: height, width: width, disabled: disabled }),
        label ? React.createElement(Text, { marginLeft: onUndefinedUseDefined(activeThemeVariation.labelMargin, 1), variationKey: activeThemeVariation.labelVariation, stretch: true }, label) : null));
};
export default CheckboxImplementation;
//# sourceMappingURL=CheckboxImplementation.js.map